import axios from "axios";

interface LoginData {
  email: string;
  password: string;
}

const login = async (data: LoginData) => {
  const auth = process.env.REACT_APP_BASIC_AUTH;
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/admin/login`,
    data,
    {
      headers: {
        Authorization: `Basic ${auth}`,
      },
    }
  );
  return response.data;
};

export default {
  login,
};
